export default {
  authed: () => import("/home/runner/work/properplan/properplan/layouts/authed.vue").then(m => m.default || m),
  blank: () => import("/home/runner/work/properplan/properplan/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/home/runner/work/properplan/properplan/layouts/default.vue").then(m => m.default || m)
}